/** @format */

import React, { useEffect, useState } from "react";

interface BouncingNotificationBadgeProps {
	count: number;
	onClick: () => void;
	className?: string;
}

export const BouncingNotificationBadge: React.FC<
	BouncingNotificationBadgeProps
> = ({ count, onClick, className }) => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		if (count > 0) {
			setIsVisible(true);
		}
	}, [count]);

	if (!isVisible || count === 0) return null;

	const baseClasses =
		"absolute -top-2 -right-2 z-10 cursor-pointer animate-bounce hover:animate-none";
	const combinedClasses = className
		? `${baseClasses} ${className}`
		: baseClasses;

	return (
		<div onClick={onClick} className={combinedClasses}>
			<div className="relative">
				{/* Pulsing ring effect */}
				<div className="absolute inset-0 bg-orange-500 rounded-full animate-ping opacity-75"></div>

				{/* Badge with bell icon (using emoji) */}
				<div className="relative bg-gradient-to-br from-orange-500 to-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center shadow-lg border-2 border-white">
					<span className="text-sm">🔔</span>
				</div>

				{/* Count indicator */}
				{count > 0 && (
					<div className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center border-2 border-white">
						{count > 9 ? "9+" : count}
					</div>
				)}
			</div>
		</div>
	);
};
